import { useState, useEffect } from 'react';
import { getStatesList } from '../services/localization';

const useStatesList = (initialCountryId) => {
  const [statesList, setStatesList] = useState([]);

  const handleChangeCountry = async (newCountryId) => {
    if (newCountryId) {
      setStatesList([]);
      const states = await getStatesList(newCountryId);
      setStatesList(states);

      return states;
    }

    return [];
  };

  useEffect(() => {
    handleChangeCountry(initialCountryId);
  }, []);

  return { statesList, setCountryId: handleChangeCountry };
};

export default useStatesList;
